import { useHistory } from 'react-router'
import { useDispatch } from 'react-redux'
import kycCore from '../services/Kyc'
import { handleError } from '../services/utils'
import { loadingActions } from '../store/slices/Loading'

const ResetHook = (): { resetFolder: () => void } => {
  const history = useHistory()
  const dispatch = useDispatch()

  const resetFolder = async () => {
    dispatch(loadingActions.loading())
    try {
      await kycCore.folder.resetFolder()
      window.location.reload()
    } catch (e) {
      dispatch(loadingActions.loaded())
      handleError(e, history, true)
    }
  }

  return { resetFolder }
}

export default ResetHook
